import { UserMatterViewHistory } from '@models/userViewHistory';

export class Create {
	static readonly type =
		'[recently-viewed] create recently viewed against matter';
	constructor(public payload: UserMatterViewHistory) {}
}

export class UpdateViewedDocs {
	static readonly type = '[recently-viewed] updating viewed docs list';
	constructor(public payload: { matterId: string; viewedDocId: string }) {}
}

export class Pin {
	static readonly type = '[recently-viewed] pin';
	constructor(public payload: { matterId: string; pin: boolean }) {}
}

export class HideFromTabs {
	static readonly type = '[recently-viewed] hide from tabs';
	constructor(public payload: { matterId: string }) {}
}
